import React from 'react';

import { NavLinkButton, Table as BSTable } from '@shared/components/bootstrap';
import { Currency, Timestamp } from '@shared/components/helpers';

import { Summary as PromotionSummary } from '@admin/components/self_storage/promotions/summary';
import { detailSelfStorageUnitURL as unitURL } from '@admin/config/routes';
import { SelfStorage__UnitFragment } from '@admin/schema';

import { UnitClimate } from './unit_climate';
import { UnitLocation } from './unit_location';
import { UnitSize } from './unit_size';

const STATUS_LABELS = {
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
  RESERVED: 'Reserved',
  RENTED: 'Rented',
  AUCTION: 'Auction',
  HELD: 'Held',
  DESIGNATED: 'Designated',
};

export const Table: React.FC<{
  units: SelfStorage__UnitFragment[];
}> = ({ units }) => (
  <BSTable>
    <thead>
      <tr>
        <th>Uploaded</th>
        <th>Facility</th>
        <th>Unit Name</th>
        <th>Unit Type</th>
        <th>Unit Size</th>
        <th>Location</th>
        <th>Climate</th>
        <th>Pricing</th>
        <th>Status</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {units.map((unit) => {
        return (
          <tr key={unit.id}>
            <td>{<Timestamp value={unit.updatedAt} format={Timestamp.Format.Date} />}</td>
            <td>{unit.facility && unit.facility.name}</td>
            <td>{unit.name}</td>
            <td>{unit.classification && unit.classification.kind && unit.classification.kind.name}</td>
            <td>
              <UnitSize unit={unit} />
            </td>
            <td>
              <UnitLocation unit={unit} />
            </td>
            <td>
              <UnitClimate unit={unit} />
            </td>
            <td>
              {unit.price && (
                <div>
                  <span>
                    Standard: <Currency value={unit.price.rate} />
                  </span>
                  <span> | </span>
                  <span>
                    Web: <Currency value={unit.price.pushRate} />
                  </span>
                </div>
              )}
              {unit.promotion && (
                <div>
                  <PromotionSummary promotion={unit.promotion} />
                </div>
              )}
            </td>
            <td>{unit.status && STATUS_LABELS[unit.status]}</td>
            <td>
              {unit.id && (
                <NavLinkButton kind="default" to={unitURL({ id: unit.id })}>
                  View
                </NavLinkButton>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  </BSTable>
);
